import { debounce } from 'lodash';
import { injectSprite } from '@utils/svg';

const symbolsToLoad = new Set<string>();
const loadedSymbols = new Set<string>();

const injectSymbolDebounced = debounce(async () => {
    if (typeof document === 'undefined') return;

    const symbols = Array.from(symbolsToLoad).filter((name) => {
        if (loadedSymbols.has(name)) return false;
        const exists = document.getElementById(name);
        if (exists) {
            loadedSymbols.add(name);
            return false;
        }

        return true;
    });

    if (!symbols.length) return;
    symbolsToLoad.clear();
    const req = `/dist/svg/?q=${symbols.join(',')}`;

    await injectSprite('svg-sprite-async', req);
    symbols.forEach((s) => {
        if (document.getElementById(s)) {
            loadedSymbols.add(s);
        }
    });
}, 100);

export function requestSvgSymbol(name: string): void {
    if (!name || typeof document === 'undefined') return;

    if (loadedSymbols.has(name) || document.getElementById(name)) {
        loadedSymbols.add(name);
        return;
    }

    symbolsToLoad.add(name);
    injectSymbolDebounced();
}
